<div class="app-layout">
  <ftr-header [logoData]="logoData"></ftr-header>

  <main>
    <ng-content></ng-content>
  </main>

  <ftr-footer></ftr-footer>
</div>
